import api from './api';

export const publicAPI = {
  registerClient: (data) => api.post('/api/public/register-client', data),
  firm: (slug) => api.get(`/api/public/firm/${encodeURIComponent(slug)}`),
  validateInvite: (token) => api.get(`/api/public/invites/${token}/validate`),
  submitEmployeeOnboarding: (token, data) => api.post(`/api/public/employee-onboarding/${token}`, data),
};

export const employeeAPI = {
  sendInvite: (clientId, data) => api.post(`/api/clients/${clientId}/employees/invite`, data),
};
